import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { TourService, TourStep } from '../../services/tour.service';
import { TourConfigService } from '../../services/tour-config.service';
import { UserSettingsService } from '../../services/user-settings.service';
import { Store } from '@ngrx/store';
import { AppState } from '../../stores/states/app.state';
import * as UserActions from '../../stores/actions/user.actions';

@Component({
  selector: 'app-tour-floating-button',
  templateUrl: './tour-floating-button.component.html',
  styleUrls: ['./tour-floating-button.component.scss']
})
export class TourFloatingButtonComponent implements OnInit, OnDestroy {
  @Input() tourSteps: TourStep[] = [];
  @Input() showDebugButton: boolean = false;
  @Input() autoStart: boolean = false;
  @Input() currentUser: any = null;

  private autoStartTimeout?: number;

  constructor(
    private tourService: TourService,
    private tourConfigService: TourConfigService,
    private userSettingsService: UserSettingsService,
    private store: Store<AppState>
  ) { }

  ngOnInit(): void {
    if (this.autoStart && this.tourSteps.length > 0) {
      this.autoStartTimeout = window.setTimeout(() => {
        this.startTour();
      }, 1000);
    }
  }

  ngOnDestroy(): void {
    if (this.autoStartTimeout) {
      clearTimeout(this.autoStartTimeout);
      this.autoStartTimeout = undefined;
    }
  }

  startTour(): void {
    if (this.tourSteps.length > 0) {
      this.tourService.initTour(this.tourSteps);
      this.tourService.start();
    } else {
      const tourSteps = this.tourConfigService.getDashboardTourSteps();
      this.tourService.initTour(tourSteps);
      this.tourService.start();
    }
  }


  hasSeenTour(): boolean {
    return this.currentUser?.settings?.showTourOnFirstVisit === false;
  }


  async resetTourSetting(): Promise<void> {
    try {
      const userSettings = this.currentUser?.settings || {};
      await this.userSettingsService.save({
        ...userSettings,
        showTourOnFirstVisit: true,
      });


      this.store.dispatch(UserActions.updateUserSettings({
        settings: { ...userSettings, showTourOnFirstVisit: true }
      }));

      this.currentUser = {
        ...this.currentUser,
        settings: { ...userSettings, showTourOnFirstVisit: true }
      };
    } catch (error) {
      console.error('Error resetting tour setting:', error);
    }
  }




  private checkTourElementsExist(): boolean {
    const requiredElements = [
      '#dashboard-title',
      '#stats-boxes',
      '#doc-types-stats',
      '#relevant-keys-stats',
      '#news-feed',
      '#today-schedule',
      '#map-component',
      '#congress-calendar'
    ];

    return requiredElements.every(selector => {
      const element = document.querySelector(selector) as HTMLElement;
      return element && element.offsetWidth > 0 && element.offsetHeight > 0;
    });
  }
}
